import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axiosIstance from '../utils/axiosIstance';
import { Button, Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';

 
import Remote from './Remote';
import axios from 'axios';
import ClientMQTT from './ClientMQTT';
import  secureSessionStorage  from  "react-secure-storage";
import { useNavigate } from "react-router-dom";

const Home = () => {

    console.log('Home');

    const [con, setCon] = useState(true);
    const [enableRemote, setEnableRemote] = useState(false);
    const [Updater, setUpdater] = useState(false);
    // const portData  =  useSelector( (state) => state.port.value);
    // const loginData     =  useSelector( (state) => state.login.value);
    const navigate      = useNavigate();
    const [ViewOnly, setViewOnly] = useState();
    const [PortWasOpen, setPortWasOpen] = useState(false);

    
    const nav = useNavigate();

    const portWasOpen = () => {
        setPortWasOpen(true);
    }


    const updateCntrl = (e) =>{
        console.log('==> updateCntrl <==')
        let u = Updater;
        setUpdater(!u);
        const isC =  secureSessionStorage.getItem("isC");
        if(isC == 1){
            setViewOnly(false);
        }else{
            setViewOnly(true);
        }
        nav("/redir");

    }


    const onClickHandle = (e) => {
        e.preventDefault();
        console.log('onClickHandle: ', e);
        axiosIstance.post()
        .then(response =>{
        })
        .catch(
            error => {
            console.log(error);
            setCon(false);
        })     
    }

    const onClickHandleLogOut = (e) => {
        e.preventDefault();
        console.log('onClickHandleLogOut: ', e);

        secureSessionStorage.setItem('token', undefined);
        secureSessionStorage.setItem('refToken', undefined);
        secureSessionStorage.setItem('port', undefined);
        secureSessionStorage.setItem('isC', undefined);
        
        window.location.reload();
    }
    

    useEffect(() => {

        console.log("use Effect Home");
    
        const token = secureSessionStorage.getItem('token');
        const refToken = secureSessionStorage.getItem('refToken');

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token
        }

        axiosIstance.post()
        .then(response =>{
            console.log(response);
            setCon(true);
        })
        .catch(
            error => {
            //alert(error);
            secureSessionStorage.setItem('token', undefined);
            secureSessionStorage.setItem('refToken', undefined);
           
        })

        setTimeout( () => setEnableRemote(true), 5000);

        const isC = secureSessionStorage.getItem("isC");

        console.log("==========> ", isC);

        if(isC == 1){
            setViewOnly(false);
        }else{
            setViewOnly(true);
        }
    
    },[])

    
        if(con){
            return(
                <>
                <Navbar expand="lg" className="bg-body-tertiary">
                    <Container>
                        <Navbar.Brand href="/">Remote Control</Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse className='justify-content-end'>
                            <Nav.Link onClick={onClickHandleLogOut}>Log Out</Nav.Link>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                {/* <div className='container'  onClick={onClickHandle}> */}
                <div className='container' >
                    <div className='row'>
                        <div className='col'>
                            {
                                enableRemote ?
                                <>
                                <Remote PortWasOpen={PortWasOpen} ViewOnly={ViewOnly}></Remote>
                                <ClientMQTT portWasOpen={portWasOpen} updateCntrl={updateCntrl}></ClientMQTT>
                                </>
                                : 
                                <div>Loading</div>
                            }
                        </div>
                    </div>
                    <div>
                        
                    </div>
                </div>
                </>
            );
        }
  
}
 
export default Home;